import React, { useContext } from "react";
import ModalContext from "../../../Contexts/openModal";
import PricingCard from "../../Pieces/PricingCard";

const PricingMonet = ({ slice, location }) => {
  const { toggleModal, setTitle } = useContext(ModalContext);
  const notEmptySlice = slice?.props?.slice.length > 0;

  return (
    <>
      {notEmptySlice && (
        <section className="relative px-4 mx-auto sm:px-12 lg:px-5 max-w-7xl">
          <article className="relative py-10 xl:mx-11 ">
            <article className="relative z-10 grid grid-cols-1 mx-auto lg:grid-cols-3 lg:flex-row md:flex-row gap-5 lg:justify-center md:justify-start">
              {slice?.props?.slice?.map?.((card, index) => (
                <PricingCard
                  heading={card?.primary?.card_title?.text}
                  description={card?.primary?.card_description?.text}
                  label={card?.primary?.card_features_label?.text}
                  subLabel={card?.primary?.card_feature_subtitle?.text}
                  items={card?.items}
                  buttonText={card?.primary?.cta_text?.text}
                  themeColor={
                    index == 0 ? "gray" : index == 1 ? "blue" : "purple"
                  }
                  onClick={() => {
                    setTitle(card?.primary?.cta_text?.text);
                    toggleModal();
                  }}
                />
              ))}
            </article>
          </article>
        </section>
      )}
    </>
  );
};

export default PricingMonet;
